export const getHistoricalBetsAlias = (isSelfExcluded?: boolean, isEmbedded?: boolean) => {
  if (isEmbedded) {
    return 'sportsEmbeddedHistoricalBets';
  } else if (isSelfExcluded) {
    return 'sportsSelfExcludedHistoricalBets';
  }

  return 'sportsHistoricalBets';
};
